var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 19"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Home---Desktop-X-Large-(1440)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 2.249A10.05 10.05 0 0 1 21.172 3 4.836 4.836 0 0 0 23.337.346a10.021 10.021 0 0 1-3.127 1.169A4.979 4.979 0 0 0 16.616 0a4.862 4.862 0 0 0-4.924 4.8 4.7 4.7 0 0 0 .128 1.09A14.105 14.105 0 0 1 1.671.878 4.68 4.68 0 0 0 1 3.289a4.763 4.763 0 0 0 2.191 3.992 5 5 0 0 1-2.23-.6v.06a4.833 4.833 0 0 0 3.95 4.7 5.063 5.063 0 0 1-2.224.082 4.914 4.914 0 0 0 4.6 3.331 10.047 10.047 0 0 1-6.115 2.053A10.279 10.279 0 0 1 0 16.845 14.207 14.207 0 0 0 7.548 19 13.725 13.725 0 0 0 21.557 5.353q0-.312-.014-.621A9.868 9.868 0 0 0 24 2.249",
  fill: "#fff",
  fillRule: "evenodd",
  "data-name": "footer-/-desktop"
}))));
export default SvgTwitter;